<div class="modal-header">
  <h5 class="modal-title">{{parametre.code}}</h5>
  <button type="button" class="btn-close btn-primary" aria-label="Close" (click)='fermerModal()'>
  </button>
</div>
<div class="modal-body">
  <div class="parametre-form">
    <div class="row">
      <div class="mb-2">
        <label><span>{{parametre.desc}}</span></label>  <label><span class="required">*</span></label>
      </div>
    </div>
    <div class="row">
        <div class="col-6">
          <textarea #inputValeur class="form-control" [formControl]="control" type="text" tabindex="0"
                 [ngClass]="control.invalid && (control.dirty ||control.touched) ? 'is-invalid' : ''"></textarea>
          <div class="invalid-feedback">
            <div *ngIf="control.errors?.['required']">Paramètre obligatoire</div>
          </div>
        </div>
    </div>
  </div>
</div>
<div class="modal-footer d-flex flex-column align-items-stretch">
  <div class="row">
    <div class="col-9">
      <button type="button" class="btn btn-modal btn-danger" (click)='fermerModal()'>Fermer</button>
    </div>
    <div class="col-3">
      <button type="submit" class="btn btn-modal btn-primary" [disabled]="control.invalid" (click)='onSubmit()' >Valider
        <div *ngIf="formModalIsSubmitting" class="col-3 text-center spinner-border text-success" role="status"></div>
      </button>
    </div>
  </div>
</div>
